var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_32760)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V24H24V0H0ZM8.39024 2.784H10.6341V5.088H8.39024V2.784ZM2.73171 2.784H5.07317V5.088H2.73171V2.784ZM4.97561 8.352V10.656H2.63415V8.352H4.97561ZM4.39024 21.024H3.41463V20.16H4.29268V21.024H4.39024ZM5.07317 16.416H2.73171V14.208H5.07317V16.416ZM10.0488 21.024H9.17073V20.16H10.0488V21.024ZM10.0488 15.648H9.17073V14.784H10.0488V15.648ZM10.7317 10.752H8.39024V8.448H10.7317V10.752ZM15.7073 21.024H14.8293V20.16H15.7073V21.024ZM15.7073 15.648H14.8293V14.784H15.7073V15.648ZM15.7073 9.984H14.8293V9.12H15.7073V9.984ZM16.4878 5.088H14.1463V2.784H16.4878V5.088ZM21.4634 21.024H20.5854V20.16H21.4634V21.024ZM21.4634 15.648H20.5854V14.784H21.4634V15.648ZM21.4634 9.984H20.5854V9.12H21.4634V9.984ZM21.4634 4.416H20.5854V3.552H21.4634V4.416Z",
    fill: "#202944"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_32760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFet);
export default __webpack_public_path__ + "static/media/fet.97bb599ad3c8eab48525bb63e46e06ab.svg";
export { ForwardRef as ReactComponent };